export const limitedHref = ['/track', '/output']
export const limitedGroups = ['SORGENIA', 'admin']
export const limitedHrefAdmin = ['/users', '/track', '/output']
export const limitedGroupsAdmin = ['admin']
